import './WorkerMienDetail.less'
import { useSearchParams } from 'react-router-dom'

const WorkerMienDetail = () => {
  const [ params ] = useSearchParams()
  const prevId = params.getAll('id')[0]
  return (
    <div className='pg-worker-mien-detail'>
      <img className='detial-img' src={`https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/workerMien/detail-${prevId}.png`} />
    </div>
  )
}

export default WorkerMienDetail